// TODO: update the useMediaQuery hook param to automatically select the width
import AppTopBar from '@shared/app-top-bar/AppTopBar'
import Sidebar from '@shared/sidebar/Sidebar'
import Drawer from '@mui/material/Drawer'
import useMediaQuery from '@mui/material/useMediaQuery'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import styles from './AppRouter.module.scss'
import BiovuRoutes from './BiovuRoutes'
import ClinicvuRoutes from './ClinicvuRoutes'

const AppRouter = ({ user, jwt }) => {
  const [drawerIsOpen, setDrawerIsOpen] = useState(false)
  const isMobileView = useMediaQuery('(max-width:950px)')

  return (
    <div className={styles['app-container']}>
      {isMobileView
        ? (
        <Drawer
          anchor="left"
          open={drawerIsOpen}
          onClose={() => setDrawerIsOpen(false)}
        >
          <Sidebar />
        </Drawer>
          )
        : (
        <div className={styles['sidebar-container']}>
          <Sidebar />
        </div>
          )}

      <div className={styles['routes-container']}>
        <AppTopBar
          isMobile={isMobileView}
          onMenuClick={() => setDrawerIsOpen(true)}
        />
        {process.env.REACT_APP_environment_type === 'clinicvu'
          ? (
          <ClinicvuRoutes />
            )
          : null}
        {process.env.REACT_APP_environment_type === 'biovu'
          ? (
          <BiovuRoutes />
            )
          : null}
      </div>
    </div>
  )
}

AppRouter.propTypes = {
  user: PropTypes.object,
  jwt: PropTypes.string
}

export default AppRouter
